import { render, staticRenderFns } from "./BtnLink.vue?vue&type=template&id=314744f2&"
import script from "./BtnLink.vue?vue&type=script&lang=js&"
export * from "./BtnLink.vue?vue&type=script&lang=js&"
import style0 from "./BtnLink.vue?vue&type=style&index=0&id=314744f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports